module.exports = __webpack_public_path__ + "media/images/pack-bg-03-81da204050e2e4b375805ad79cba573d.svg";